import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { KlmrFuelTruckAddPage } from '../klmr-fuel-truck-add/klmr-fuel-truck-add';

@IonicPage()
@Component({
  selector: 'page-klmr-fuel-truck',
  templateUrl: 'klmr-fuel-truck.html',
})
export class KlmrFuelTruckPage {
  fuelTruckList: any = [];
  actionAllowed:boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider) {
  }

  ionViewDidLoad() {
    this.getPermission();
    this.getfuelTruckList();
  }



  getfuelTruckList() {
    this.fuelTruckList = [];
    this.utiltiy.startLoading();
    this.api.get("/prestart/fuel/fuel_truck/get", false)
      .then((result: any) => {
        console.log("result", result)
        let fuelTruckList = result.result;
        this.calculatefuelTruckList(fuelTruckList)
        this.utiltiy.stopLoading();
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  async calculatefuelTruckList(fuelTruckList){
   
    let array = [];
    let totalLtrs = 0;
    let keys = Object.keys(fuelTruckList);
    keys = keys.reverse();
    keys.forEach(element => {
      totalLtrs = 0;
      console.log("---")
      let monthKeys = Object.keys(fuelTruckList[element].months)
      monthKeys = monthKeys.reverse();

      let childArray = [];
      let obj = {} as any;
      obj.name = element;
      monthKeys.forEach(element_ => {
        const monthNames = ["","January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
        ];
        if(fuelTruckList[element].months[element_].records.length > 0){

          // let int = parseFloat(fuelTruckList[element].months[element_].LTRS);
          // fuelTruckList[element].months[element_].LTRS = int
          // totalLtrs = totalLtrs+int;
          // console.log("fuelTruckList[element].months[element_]",fuelTruckList[element].months[element_])
          // console.log("totalLtrs",totalLtrs)
          totalLtrs = fuelTruckList[element].LTRS;
          // console.log("fuelList[element].months[element_]",fuelList[element].months[element_])
          console.log("totalLtrs",totalLtrs)
          childArray.push({"records":fuelTruckList[element].months[element_], "monthName": monthNames[element_]})
        }
      });
      obj.totalLtr = totalLtrs;
      obj.children = childArray;
      array.push(obj)
    });
    console.log("array----",array)
    this.fuelTruckList = array;
  }

  
  maintenancetoggleSection(i){
    this.fuelTruckList[i].open = !this.fuelTruckList[i].open;
  }

  maintenancetoggleItem(i,j){
    this.fuelTruckList[i].children[j].open = ! this.fuelTruckList[i].children[j].open;
  }


  async deleteRecord(id) {
    let status = await this.utiltiy.showDialog();
    if (status) {
      this.deleteTruckList(id);
    }
    console.log("status", status);
  }


  deleteTruckList(id) {
    this.api.delete(`/prestart/fuel/fuel_truck/delete/${id}`, false)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.getfuelTruckList();
        }

      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }
  
  addFuelTruck(){
   this.navCtrl.push(KlmrFuelTruckAddPage, { param: null });
 }
 updateFuelTruck(prestart){
   this.navCtrl.push(KlmrFuelTruckAddPage, { param: prestart });
 }

 async getPermission(){
  this.actionAllowed =  await this.utiltiy.getPagePermission("klmr-fuel-truck-rw");
 }

}



// WEBPACK FOOTER //
// ./src/pages/klmr-fuel-truck/klmr-fuel-truck.ts